import { createSlice } from '@reduxjs/toolkit';
import { addNewInvoice, changeInvoiceStatus, editInvoice, getAllInvoiceList, getInvoiceById } from './invoiceService';

const initialState = {
  allInvoiceList: {
    isInvoiceListLoading: null,
    isInvoiceListSuccess: null,
    invoiceListMessage: null,
    pageCount: 0,
    invoiceList: [],
  },

  newInvoice: {
    isInvoiceCreating: null,
    isInvoiceCreated: null,
    invoiceCreationMsg: null,
  },

  editedInvoice: {
    isEditingInvoice: null,
    isInvoiceEdited: null,
    invoiceEditedMsg: null
  },

  invoiceDetails: {
    isInvoiceLoading: null,
    isInvoiceSuccess: null,
    invoice: null
  },

  changeStatus: {
    isStatusLoading: null,
    isStatusSuccess: null,
  },
};

const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllInvoiceList.pending, (state) => {
        state.allInvoiceList = {
          ...initialState.allInvoiceList, // Reset to initial state
          isInvoiceListLoading: true,
          invoiceListMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllInvoiceList.rejected, (state, action) => {
        state.allInvoiceList = {
          ...initialState.allInvoiceList,
          isInvoiceListLoading: false,
          isInvoiceListSuccess: false,
          invoiceListMessage: action.payload || 'Error occurred while fetching invoiceList',
        };
      })

      // FULFILLED
      .addCase(getAllInvoiceList.fulfilled, (state, action) => {
        state.allInvoiceList = {
          ...initialState.allInvoiceList,
          isInvoiceListLoading: false,
          isInvoiceListSuccess: true,
          pageCount: action.payload.pageCount || 0,
          invoiceList: action.payload.data || [],
        };
      });

    //Invoice creating
    builder
      .addCase(addNewInvoice.pending, (state) => {
        state.newInvoice = {
          ...initialState.newInvoice, // Reset to initial state
          isInvoiceCreating: true,
          invoiceCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewInvoice.rejected, (state, action) => {
        state.newInvoice = {
          ...initialState.newInvoice,
          isInvoiceCreating: false,
          isInvoiceCreated: false,
          invoiceCreationMsg: action.payload || 'Error occurred while creating the invoice.',
        };
      })

      // FULFILLED
      .addCase(addNewInvoice.fulfilled, (state, action) => {
        state.newInvoice = {
          ...initialState.newInvoice,
          isInvoiceCreating: false,
          isInvoiceCreated: true,
          invoiceCreationMsg: action.payload || 'Successfully created the invoice.',
        };
      });

    //Invoice editing
    builder
      .addCase(editInvoice.pending, (state) => {
        state.editedInvoice = {
          ...initialState.editedInvoice, 
          isEditingInvoice: true,
          invoiceEditedMsg: 'Loading',
        };
      })

      .addCase(editInvoice.rejected, (state, action) => {
        state.editedInvoice = {
          ...initialState.editedInvoice,
          isEditingInvoice: false,
          isInvoiceEdited: false,
          invoiceEditedMsg: action.payload || 'Error occurred while editing the invoice.',
        };
      })

      .addCase(editInvoice.fulfilled, (state, action) => {
        state.editedInvoice = {
          ...initialState.editedInvoice,
          isEditingInvoice: false,
          isInvoiceEdited: true,
          invoiceEditedMsg: action.payload || 'Successfully edited the invoice.',
        };
      });

       //Invoice details
    builder
    .addCase(getInvoiceById.pending, (state) => {
      state.invoiceDetails = {
        ...initialState.invoiceDetails, 
        isInvoiceLoading: true,
      };
    })

    .addCase(getInvoiceById.rejected, (state, action) => {
      state.invoiceDetails = {
        ...initialState.invoiceDetails,
        isInvoiceLoading: false,
        isInvoiceSuccess: false,
      };
    })

    .addCase(getInvoiceById.fulfilled, (state, action) => {
      state.invoiceDetails = {
        ...initialState.invoiceDetails,
        isInvoiceLoading: false,
        isInvoiceSuccess: true,
        invoice: action.payload,
      };
    });

     //Change Invoice Status
     builder
     .addCase(changeInvoiceStatus.pending, (state) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: true,
      };
     })

     .addCase(changeInvoiceStatus.rejected, (state, action) => {
      state.changeStatus = {
        ...initialState.changeStatus,
        isStatusLoading: false,
        isStatusSuccess: false,
      };
     })

     .addCase(changeInvoiceStatus.fulfilled, (state, action) => {
       state.changeStatus = {
         ...initialState.changeStatus,
         isStatusLoading: false,
         isStatusSuccess: true,
       };
     });
  },
});

export default invoiceSlice.reducer;
